
import * as React from 'react';
import {default as NumberFormat, NumberFormatProps} from 'react-number-format';
import { FormControl } from 'react-bootstrap';
import {Field,NumLang} from '../../store/types';
import EditorProps from '../editorinterface';

interface Props extends EditorProps {

};

class NumberEditor extends React.Component<Props> {

	constructor(props: Props){
        super(props);
        this.onChange = this.onChange.bind(this);
    }

	public render() {
		var props = this.props;
		return (
			<NumberFormat customInput={FormControl}
				value={props.value}
				isNumericString={typeof props.value === 'string'}
				onValueChange={this.onChange}
				readOnly={props.field.readOnly===1}
				{...numberFormatProps(props.field)} />
		);
	}

	private onChange(values: {formattedValue: string,value:string, floatValue: number}) {
		const {value} = values;
		this.props.onChange(this.props.field.id,value.length===0 ? null : value);
	}

}

function numberFormatProps(field: Field) {
	const defaultProps : NumberFormatProps = {
		type: 'tel',
		thousandSeparator: (field.type!='phone'),
		decimalSeparator: '.',
		allowLeadingZeros: (field.type=='phone'),
	};
	if(!field.numformat || field.numformat.length===0) {
		return defaultProps;
	}
	const numFormat = field.numformat;
	const thousandSeparator = numFormat.indexOf(',')!==-1 ? ',' : '';
	const currency = getCurrencySymbol(field.numlang);
	const prefix = numFormat.startsWith('$ ') ? currency+' ' : numFormat.startsWith('$') ? currency : '';
	const suffix = numFormat.endsWith(' $') ? ' '+currency : numFormat.endsWith('$') ? currency : '';
	let decimalScale;
	if(field.type==='int') {
		decimalScale = 0;
	}else {
		const matches = new RegExp('\\.(0+)').exec(numFormat);
		decimalScale = matches && matches.length? matches[1].length : 0;
	}


	return Object.assign(defaultProps,{
		prefix: prefix,
		suffix: suffix,
		thousandSeparator: thousandSeparator,
		decimalScale: decimalScale
	});
}

function getCurrencySymbol(numLang?: NumLang | null):string {
	switch(numLang) {
		case 'en':
			return '$';
		case 'en-gb':
			return '£';
		case 'fr':
		default:
			return '€';
	}
}

export default NumberEditor;



// WEBPACK FOOTER //
// ./src/components/numbereditor/index.tsx